<template>
  <div class="layout__container layout__padding-20-0">
    <div class="layout__padding-clear layout__width-50">
      <StepGuide :stepCount="0"></StepGuide>
    </div>

    <div class="layout__padding-clear layout__width-80">
      <div class="text__align-center text__colour-white">
        <div class="layout__padding-clear layout__width-50 layout__padding-40px-0">
          <h2 class="text__colour-teal">Analysing your artwork</h2>
        </div>
      </div>

      <div class="layout__height-150px">
        <div
          class=""
          v-loading="true"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import Router from '../../../router';
import StepGuide from '@/components/tools/pdfupload/StepGuide.vue';
import { axios } from '@/mixins/Axios.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { backing } from '@/mixins/Backing.js';

export default {
  name: 'analysing',

  components: {
    StepGuide
  },

  props: {
    searchParams: Object
  },

  mixins: [
    axios,
    dataFormatter,
    backing
  ],

  data() {
    return {
      failed: false,
      queryParamsHelper: [
        'propertyName',
        'branchCode',
        'filename',
        'reference',
        'source',
        'token'
      ],
      printJob: {},
      error: false
    };
  },

  created() {
    if (typeof this.searchParams !== 'undefined') {
      for (let i = 0; this.queryParamsHelper.length > i; i++) {
        const param = this.queryParamsHelper[i];
        const queryParam = this.searchParams[param];
        // console.log(this.searchParams[param])
        window.sessionStorage.setItem('_' + param, queryParam);
        // console.log(queryParam)

        if (queryParam === null) {
          this.error = true;
        } else if (queryParam === '') { // todo add or statements null, undefined
          this.error = true;
        }
      }
    }

    if (this.error === true) {
      Router.push({
        name: '/instant-print/error',
        params: {
          errorType: 'incomplete'
        }
      });
    } else {
      const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfupload/orders/`;
      const connectionResults = {
        'fileUri': window.sessionStorage.getItem('_filename'),
        'branchId': window.sessionStorage.getItem('_branchCode'),
        'customerRef': window.sessionStorage.getItem('_propertyName'),
        'sourcePartner': window.sessionStorage.getItem('_source').toUpperCase(),
        'partnerRef': window.sessionStorage.getItem('_reference'),
      };

      console.log('stuff');
      console.log(connectionResults);

      Axios.post(url, connectionResults, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response);
          this.printJob = response.data;

          this.handlePrintJobs(this.printJob);

          const basketTotals = {
            instantPrint: JSON.parse(window.sessionStorage.getItem('_printJobs'))?.length || 0,
          };

          this.$store.dispatch('incrementPhotofixrTotal', basketTotals);

          // window.sessionStorage.setItem('_printJob', JSON.stringify(this.printJob));

          if (this.printJob.imageUrlThumb === null) {
            Router.push({
              name: '/instant-print/error',
              params: {
                printJob: this.printJob,
                errorType: 'nopdf',
                issue: 'laminations'
              }
            });
          } else {
            Router.push({
              name: '/instant-print/artwork-preview',
              params: {
                printJob: this.printJob,
                searchParams: this.searchParams
              }
            });
          }
        })
        .catch(error => {
          if (error.response.status === 422) {
            console.log('rifat caught error');
            Router.push({
              name: '/instant-print/error',
              params: {
                printJob: this.printJob,
                errorType: 'nopdf',
                issue: 'laminations'
              }
            });
          } else if (error.response.status === 403) {
            console.log('rifat caught error');
            Router.push({
              name: '/instant-print/error',
              params: {
                errorType: 'onhold'
              }
            });
          }
        });
    }
  },

  methods: {}
};
</script>
